import React, {Component} from 'react';
import {object} from 'prop-types';

import {connect} from 'react-redux';

import {orderBy, isEmpty} from 'lodash';

import Paper from '@material-ui/core/Paper';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import PanelHeader from '../../components/PanelHeader';
import CampusSitesTableAndSearch from './CampusSitesTableAndSearch';

import ClientsTable from './ClientsTable';
import ContactsTable from './ContactsTable';

import AreaPanelInsert from './AreaPanelInsert';
import EquipmentPanelInsert from './EquipmentPanelInsert';
import SystemPanelInsert from './SystemPanelInsert';

import {isAllowed} from '../../helpers/auth';
import {Permissions} from '../../helpers/permissions';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ArchitectActions from '../../actions/architectActions';
import * as CoreActions from '../../actions/coreActions';

import ConfirmBulkEquipmentDeleteModal from '../Modals/ConfirmBulkEquipmentDeleteModal';

import classes from './DataPanel.module.css';

class DataPanel extends Component {

    state = {
        searchFilter:                        '',
        selectedEquipment:                   [], 
        confirmBulkEquipmentDeleteModalOpen: false, 
    }

    handleContactFilter = searchTerm => {
        const {fetchContacts, selectedNode} = this.props;

        if (isEmpty(searchTerm)) {
            fetchContacts(selectedNode.id);

            return;
        }

        fetchContacts(selectedNode.id, {searchFilter: searchTerm});
    }

    handleClientFilter = searchFilter => {
        const {fetchClientNodes, selectedNode} = this.props;

        if (isEmpty(searchFilter)) {
            fetchClientNodes(selectedNode.id);

            return;
        }

        fetchClientNodes(selectedNode.id, {searchFilter});
    }

    handleCampusSiteFilter = searchFilter => {
        const {fetchCampusAndSiteNodes, selectedNode} = this.props;

        if (isEmpty(searchFilter)) {
            fetchCampusAndSiteNodes(selectedNode.id);

            return;
        }

        fetchCampusAndSiteNodes(selectedNode.id, {searchFilter});
    }

    handleBulkEquipmentDelete = async () => {
        const {
            deleteEquipmentBulk,
            selectedNode,
            setProgressBarLoading
        } = this.props;
        const { selectedEquipment } = this.state;

        if (isEmpty(selectedEquipment)) return;

        const parents = selectedNode.parent.split('/');
        const siteId = parents[parents.length - 1];

        setProgressBarLoading(true);
        await deleteEquipmentBulk(selectedEquipment, siteId);
        setProgressBarLoading(false);

        this.closeBulkEquipmentDeleteModal();
    };
    
    openBulkEquipmentDeleteModal = () => {
        this.setState({ confirmBulkEquipmentDeleteModalOpen: true });
    }

    closeBulkEquipmentDeleteModal = () => {
        this.setState({ confirmBulkEquipmentDeleteModalOpen: false });
    }

    handleBulkEquipmentSelect = selectedEquipment => {
        this.setState({ selectedEquipment });
    }

    handleSort = (property) => {
        return (event) => {
            this.props.reorderItems(property);
        };
    }

    handleSearch = (searchFilter, topic) => {
        const {
            fetchEquipment,
            fetchAreas,
            fetchSystems,
            selectedNode
        } = this.props;

        let fetchFn, ids, parentId;

        this.setState({ searchFilter });

        switch (topic) {
            case 'area':
                fetchFn = fetchAreas;
                break;
            case 'equipment':
                fetchFn = fetchEquipment;
                break;
            case 'system':
                fetchFn = fetchSystems;
                break;
            case 'areaItem':
                ids = selectedNode.parent.split('/');
                parentId = ids[ids.length - 2];

                if (isEmpty(searchFilter)) {
                    fetchEquipment(parentId);
                } else {
                    fetchEquipment(parentId, {}, {searchFilter});
                }
                return;
            default:
                break;
        }

        if (isEmpty(searchFilter)) {
            fetchFn(selectedNode);
        } else {
            fetchFn(selectedNode, {}, {searchFilter});
        }
    }

    renderTitle = type => {
        switch (type) {
            case 'area':
            case 'equipment':
            case 'sensor':
            case 'site':
            case 'system':
                return type;
            case 'client':
                return 'Contacts';
            case 'campus':
                return 'Sites';
            case 'company':
                return 'Clients';
            case 'equipmentItem':
                return 'Equipment';
            case 'areaItem':
                return 'Equipment serving this Area';
            case 'systemItem':
                return 'System';
            default:
                return 'Data Panel';
        }
    }

    renderTable = type => {
        const {
            areas,
            campusSites,
            clients,
            companyInfo,
            contacts,
            currentScopes,
            equipment,
            filteredEquipment,
            onToggleCreateContactModal,
            onToggleDeleteCampusSiteModal,
            onToggleDeleteContactModal,
            onToggleDeleteLinkModal,
            onToggleDeleteEquipmentEntityModal,
            onToggleEditContactModal,
            order,
            orderBy,
            systems
        } = this.props;

        const { selectedEquipment } = this.state;

        const isFullArchitectAllowed = isAllowed(currentScopes, Permissions('architectFull'));

        switch (type) {
            case 'area':
                return (
                    <AreaPanelInsert
                        handleSearch={this.handleSearch}
                        areas={areas}
                        order={order}
                        orderBy={orderBy}
                        handleSort={this.handleSort}
                        type={type}
                    />
                );
            case 'areaItem':
                return (
                    <EquipmentPanelInsert
                        handleSearch={this.handleSearch}
                        equipment={filteredEquipment}
                        onToggleDeleteEquipmentEntityModal={onToggleDeleteEquipmentEntityModal}
                        order={order}
                        orderBy={orderBy}
                        handleSort={this.handleSort}
                        type={type}
                        isFullArchitectAllowed={isFullArchitectAllowed}
                        showContextMenu={true}
                        selectedEquipment={selectedEquipment}
                    />
                );
            case 'campus':
                return (
                    <CampusSitesTableAndSearch
                        campusSites={campusSites}
                        isFullArchitectAllowed={isFullArchitectAllowed}
                        order={order}
                        orderBy={orderBy}
                        handleSort={this.handleSort}
                        onToggleDeleteCampusSiteModal={onToggleDeleteCampusSiteModal}
                        selectedClient={this.props.selectedClient}
                        selectedNode={this.props.selectedNode}
                    />
                );
            case 'client':
                return (
                    <React.Fragment>
                        <ActionBar
                            onSearch={this.handleContactFilter}
                        >
                            <ActionBarItem
                                onClick={() => onToggleCreateContactModal(true)}
                                hidden={!isFullArchitectAllowed}
                                type="add"
                            >
                                New Contact
                            </ActionBarItem>
                        </ActionBar>
                        <div className={classes.scrollContainer}>
                            <ContactsTable
                                companyInfo={companyInfo}
                                contacts={contacts}
                                isFullArchitectAllowed={isFullArchitectAllowed}
                                onToggleDeleteContactModal={onToggleDeleteContactModal}
                                onToggleDeleteLinkModal={onToggleDeleteLinkModal}
                                onToggleEditContactModal={onToggleEditContactModal}
                                order={order}
                                orderBy={orderBy}
                                onSort={this.handleSort}
                            />
                        </div>
                    </React.Fragment>
                );
            case 'company':
                return (
                    <React.Fragment>
                        <ActionBar
                            onSearch={this.handleClientFilter}
                        />
                        <div className={classes.scrollContainer}>
                            <ClientsTable
                                clients={clients}
                                order={order}
                                orderBy={orderBy}
                                onSort={this.handleSort}
                            />
                        </div>
                    </React.Fragment>
                );
            case 'equipment':
                return (
                    <React.Fragment>
                        <EquipmentPanelInsert
                            handleSearch={this.handleSearch}
                            handleSelect={this.handleBulkEquipmentSelect}
                            handleDelete={this.openBulkEquipmentDeleteModal}
                            equipment={equipment}
                            selectedEquipment={selectedEquipment}
                            type={type}
                            showContextMenu={false}
                        />
                        <ConfirmBulkEquipmentDeleteModal
                            onConfirm={this.handleBulkEquipmentDelete}
                            onClose={this.closeBulkEquipmentDeleteModal}
                            open={this.state.confirmBulkEquipmentDeleteModalOpen}
                        />
                    </React.Fragment>
                );
            case 'system':
                return (
                    <SystemPanelInsert
                        handleSearch={this.handleSearch}
                        systems={systems}
                        order={order}
                        orderBy={orderBy}
                        handleSort={this.handleSort}
                        type={type}
                        showContextMenu={false}
                    />
                );
            default:
                return (
                    <p>Data Panel Loading</p>
                );
        }
    }

    render() {
        const {selectedNode} = this.props;

        if (!selectedNode) return null;

        const title = this.renderTitle(selectedNode.type);

        return (
            <Paper className={classes.DataPanel}>
                <div className={classes.header}>
                    <PanelHeader
                        title={title}
                    />
                </div>
                {this.renderTable(selectedNode.type)}
            </Paper>
        );
    }
}

DataPanel.defaultProps = {
    selectedNode: {}
};

DataPanel.propTypes = {
    selectedNode: object
};

const mapStateToProps = state => {
    const {
        areas,
        campusSites,
        clientNodes,
        contacts,
        equipment,
        filteredEquipment,
        order,
        orderBy: orderByKey,
        selectedNode,
        systems
    } = state.architect;

    return {
        areas:             orderBy(areas, [orderByKey], order),
        campusSites:       orderBy(campusSites, [orderByKey], order),
        clients:           orderBy(clientNodes, [orderByKey], order),
        companyInfo:       state.companyInfo,
        contacts:          orderBy(contacts, [orderByKey], order),
        currentScopes:     state.core.currentScopes,
        equipment:         orderBy(equipment, [orderByKey], order),
        filteredEquipment: orderBy(filteredEquipment, [orderByKey], order),
        order,
        orderBy:           orderByKey,
        selectedClient:    state.client.selectedClient,
        selectedNode,
        systems:           orderBy(systems, [orderByKey], order)
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ArchitectActions,
    ...CoreActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataPanel);
